

window.main = true;

if (!window.prefetch) {
    angular.bootstrap(document.body, ['app']);
    require('./app.js');
}


//////////////////
// WEBPACK FOOTER
// ./js/bootstrap.js
// module id = 0
// module chunks = 1